<div class="spinnerContainer" *ngIf="isLoading; else eventMain">
  <mat-spinner  class="spinner" [diameter]="100" [color]="'primary'"></mat-spinner>
</div>

<ng-template #eventMain>
  <ul class="nearby_event__listing" *ngIf="aviationEvents && aviationEvents.length > 0; else eventPlaceholder">
    <li class="nearby_event__event" *ngFor="let aviationEvent of this.aviationEvents">
      <div class="nearby_event__event-type">{{ aviationEventTypeDesc[aviationEventType[aviationEvent.typeId]].toLowerCase() }}</div>
      <div class="nearby_event__header-container">
        <div class="nearby_event__header">
          <a target="_blank" [routerLink]="['/event', aviationEvent.eventId]"><div class="nearby_event__title" *ngIf="aviationEvent.title" [innerHtml]="aviationEvent.title"></div></a>
          <div class="nearby_event__text">{{ getDateString(aviationEvent, 'start') }}<ng-container *ngIf="getDateString(aviationEvent, 'start') !== getDateString(aviationEvent, 'end')"> - {{ getDateString(aviationEvent, 'end') }}</ng-container></div>
          <div class="nearby_event__text" *ngIf="aviationEvent.venueLocationName">Location: {{ aviationEvent.venueLocationName }}</div>
        </div>
        <div *ngIf="aviationEvent.photos && aviationEvent.photos.length > 0 && aviationEvent.photos[0].thumbnailPhotoPath" class="nearby_event__photo">
          <img class="nearby_event__image-border" [src]="aviationEvent.photos[0].thumbnailPhotoPath" />
        </div>
      </div>
      <div class="nearby_event__text">Description:</div>
      <!-- <app-truncated-text *ngIf="aviationEvent.description" class="nearby_event__body" [text]="aviationEvent.description" [limit]="250"></app-truncated-text> -->
      <div class="nearby_event__body">{{ aviationEvent.shortDescription }}</div>
      <!-- <div class="nearby_event__photo-gallery-spacer" *ngIf="article.Image"></div>
      <img *ngIf="article.Image" [src]="article.Image" width="340" height="191" /> -->
      <div class="nearby_event__text"><a target="_blank" [routerLink]="['/event', aviationEvent.eventId]">Learn More</a></div>
    </li>
  </ul>
  <div class="nearby_event__footer" *ngIf="aviationEvents && aviationEvents.length > 0">Find more events and submit new events <a target="_blank" [routerLink]="['/']" [queryParams]="{t: 'events'}">HERE</a></div>
</ng-template>
<ng-template #eventPlaceholder>
  <ul class="nearby_event__listing">
    <li class="nearby_event__event">
      <div class="nearby_event__text">No nearby events found.</div>
    </li>
  </ul>
  <div class="nearby_event__footer">Find more events and submit new events <a target="_blank" [routerLink]="['/']" [queryParams]="{t: 'events'}">HERE</a></div>
</ng-template>
